import { useNavigate } from 'react-router-dom';
import Button from '../../components/common/Button';
import logoWithName from '../../assets/images/TapTabLogoBlackSmallWithName.png';
import { useRestaurantContext } from '../../contexts/RestaurantContext';
import { PAGE_SETTINGS_ACCOUNT } from '../../constants/UriConstants';

const StripeOnboardingSuccessPage = () => {
  const navigate = useNavigate();
  const { currentRestaurant } = useRestaurantContext();

  const handleClose = () => {
    navigate(`/${PAGE_SETTINGS_ACCOUNT}`);
  };

  const handleOpenStripeDashboard = () => {
    const stripeAccountId = currentRestaurant?.stripeAccountId;
    const baseUrl = 'https://dashboard.stripe.com';
    const stripeDashboardUrl = stripeAccountId ? `${baseUrl}/${stripeAccountId}/` : baseUrl;
    window.open(stripeDashboardUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="stripe-onboarding-success-page">
      <button
        type="button"
        className="stripe-onboarding-success-close"
        onClick={handleClose}
        aria-label="Close"
      >
        ×
      </button>
      <div className="stripe-onboarding-success-content">
        <img src={logoWithName} className="stripe-onboarding-success-logo" alt="TapTab logo" />
        <h1 className="stripe-onboarding-success-title">You successfully finished onboarding on Stripe</h1>
        <p className="stripe-onboarding-success-message">
          Your Stripe Connect account is set up. Click on the button below to access the Stripe Dashboard and upload additional documents.
        </p>
        <Button className="stripe-onboarding-success-button" onClick={handleOpenStripeDashboard}>
          OPEN STRIPE DASHBOARD
        </Button>
      </div>
    </div>
  );
};

export default StripeOnboardingSuccessPage;
